import React from "react";
import * as S from "./styled";
import PT from "prop-types";
import { Link } from "react-router-dom";
import Avatar from "_c/Avatar";
import { LinkGenerator } from "@/utils/LinkGenerator";
import CroppedText from "_c/CroppedText";
import { HeartsPreloader } from "_c/preloader";
import CombScissorsIcon from "_c/icon/CombScissors";

const Meta = ({ slide, meta, loading, shouldFetchSlide, t }) => {
  if (shouldFetchSlide) {
    if (loading) {
      return <HeartsPreloader style={{ marginTop: "15px" }} size="md" />;
    } else {
      if (!meta) return null;
    }
  }
  const { master, client, saloon, service } = meta;
  return (
    <S.Wrap>
      <S.Participants>
        {master && (
          <S.Participant>
            <Link
              aria-label={t("common:master")}
              to={LinkGenerator.masterProfile(master._id)}
            >
              <Avatar avatar={master.user.avatar} sex={master.user.sex} />
            </Link>
            <S.StatusBadge>{t("common:master")}</S.StatusBadge>
          </S.Participant>
        )}
        {client && (
          <S.Participant>
            <Link
              aria-label={t("common:client")}
              to={LinkGenerator.clientProfile(client._id)}
            >
              <Avatar avatar={client.avatar} sex={client.sex} />
            </Link>
            <S.StatusBadge>{t("common:client")}</S.StatusBadge>
          </S.Participant>
        )}
        {saloon && (
          <S.Participant>
            <Link
              aria-label={t("common:salon")}
              to={LinkGenerator.saloonProfile(saloon._id)}
            >
              <Avatar avatar={saloon.logo} />
            </Link>
            <S.StatusBadge>{t("common:salon")}</S.StatusBadge>
          </S.Participant>
        )}
      </S.Participants>
      {service && (
        <S.Service>
          <CombScissorsIcon color="var(--font-color-emp)" width="16" />
          <span>{service.title}</span>
        </S.Service>
      )}
      {slide.desc && (
        <CroppedText limit={255} text={slide.desc} Component={S.Desc} />
      )}
    </S.Wrap>
  );
};
Meta.propTypes = {
  participants: PT.arrayOf(PT.string),
  comments: PT.number,
  slide: PT.object,
  isFavorite: PT.bool,
  shouldFetchSlide: PT.bool,

  t: PT.func.isRequired,
  onStarClick: PT.func,
  toggleLike: PT.func,
};
export default Meta;
